<template>
  <div>
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <router-link
            :to="`/directory/kindergarten-directory`"
            class="nav-link"
            active-class="active"
        >
          Справочник ДО
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
            :to="`/directory/kindergarten-special-standard`"
            class="nav-link"
            active-class="active"
        >
          Лимитный стандарт
        </router-link>
      </li>
    </ul>

    <div class="child-info-part-content">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted} from "vue";
import Multiselect from "vue-multiselect";
import router from "@/router";

export default defineComponent({
  name: "DirectoryView",
  components: {Multiselect},
  setup() {

    onMounted(async () => {
      if (router.currentRoute.value.path === `/directory`) {
        router.push(`/directory/kindergarten-directory`);
      }
    })

    return {
    }
  }
});
</script>

<style scoped></style>